<script setup lang="ts">
import BaseModal from './BaseModal.vue';
import SettingItem from '@/shared/ui/SettingItem/SettingItem.vue'

const emit = defineEmits(['close', 'success']);

const close = () => {
  emit('close');
};
</script>

<template>
  <BaseModal :is-open="true" title="Настройки" @close="close" :forced-to-be-open="false">
    <h4 class="settings-title">Новый функционал</h4>
    <SettingItem
      id="showShoppingFeed"
      title="Показывать ленту покупок"
      description="Лента покупок показывает что купили другие покупатели"
      type="checkbox"
    />

    <h4 class="settings-title">Приватность</h4>
    <SettingItem
      id="privacyShoppingFeed"
      title="Подписывать мои покупки в ленте покупок"
      description="Если эта функция отключена, ваши покупки все равно отображаются, только без информации о покупателе"
      type="checkbox"
    />

    <h4 class="settings-title">Подключение</h4>
    <SettingItem
      id="useYandexStorage"
      title="Использовать Яндекс Облако для изображений"
      description="Ускорит загружку изображений. Могут возникнуть проблемы при использовании VPN"
      type="checkbox"
    />
  </BaseModal>
</template>
<style lang="scss" scoped>
.settings-title {
  font-size: 20px;
  margin: 8px 0 12px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #ddd;
}
</style>
